/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Tue Mar 11 2025
 **/

import { Row, Tooltip } from "@/frameworks/designStuff";
import { _T } from "@rfice/language";

export const QuillToolbar = ({ variant, roomID }: { variant?: ChatUI.Size; roomID: string }) => (
	<Row
		gap={variant === "fullSize" ? "4px" : "8px"}
		id={`toolbar-${roomID}`}
		className="ql-formats"
		style={{
			border: 0,
			position: "relative",
			zIndex: 1,
			width: "-webkit-fill-available",
			height: "100%",
			borderRadius: "8px 8px 0px 0px",
			padding: `${variant === "transparent" ? "8px 8px 10px" : "4px 10px"}`,
			background: "rgba(255, 255, 255, 0.8)"
		}}
	>
		{[
			{ className: "ql-bold", message: "굵게" },
			{ className: "ql-italic", message: "기울임꼴" },
			{ className: "ql-strike", message: "취소선" },
			{ className: "ql-list", value: "ordered", message: "순서가 지정된 목록" },
			{ className: "ql-list", value: "bullet", message: "글머리 기호 목록" },
			{ className: "ql-link", message: "링크" },
			{ className: "ql-blockquote", message: "인용구" },
			{ className: "ql-code", message: "코드" },
			{ className: "ql-code-block", message: "코드 블록" }
		].map(({ className, value, message }) => (
			<Tooltip
				key={`${className}-${value || "default"}-tooltip`}
				message={_T("{{message}}", { message })}
				hasIcon={false}
			>
				<button
					className={className}
					value={value}
					style={{
						width: `${variant === "transparent" ? "24px" : "28px"}`,
						height: `${variant === "transparent" ? "24px" : "28px"}`
					}}
				/>
			</Tooltip>
		))}
	</Row>
);
export default QuillToolbar;
